const translations = {
  "en": {
    "Activate it, and Ed keeps it on track for you.": "Activate it, and Ed keeps it on track for you.",
    "Adapts as your life and goals change": "Adapts as your life and goals change",
    "I turned your check-up into a plan you can act on.": "I turned your check-up into a plan you can act on.",
    "Make your plan real.": "Make your plan real.",
    "Reveal your comprehensive, long-term financial plan": "Reveal your comprehensive, long-term financial plan",
    "Track progress and flag risks the moment you drift off target": "Track progress and flag risks the moment you drift off target",
    "Your plan is ready. Unlock full access.": "Your plan is ready. Unlock full access."
  },
  "zh-tw": {
    "Activate it, and Ed keeps it on track for you.": "啟用後，Ed 會為你持續追蹤進度。",
    "Adapts as your life and goals change": "隨著你的生活與目標改變而調整",
    "I turned your check-up into a plan you can act on.": "我把你的健檢結果變成了一份你可以執行的計畫。",
    "Make your plan real.": "實現你的計畫。",
    "Reveal your comprehensive, long-term financial plan": "呈現你全面的長期財務規劃",
    "Track progress and flag risks the moment you drift off target": "追蹤進度，一偏離目標就立即標示風險",
    "Your plan is ready. Unlock full access.": "你的方案已就緒。解鎖完整權限。"
  }
};

export default translations;
